






import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'LangPicker'
})
export default class LangPicker extends Vue {
  pick (locale: string) {
    this.$i18n.locale = locale
  }
}
